<template>
	<div class="ModuleHeader">
		<div class="ModuleHeaderLogo">
			<el-image :src="ModuleHeaderLogoUrl"/>
		</div>
		<div class="ModuleHeaderUser">
			<AccountInfoPopover 
				@Admin_Update_Password_Show="AdminPasswordDialogVisible = true" 
				@Admin_Update_KeyCode_Show="AdminKeyCodeDialogVisible = true"
			>
				<div class="ModuleHeaderUserInfo">
					<div class="ModuleHeaderUserInfoAvatar">
						<el-icon><UserFilled /></el-icon>
					</div>
					<div class="ModuleHeaderUserInfoName">{{AdminName}}</div>
				</div>
			</AccountInfoPopover>
			<UpdatePasswordDialog v-model:Visible="AdminPasswordDialogVisible" />
			<UpdateKeyCodeDialog v-model:Visible="AdminKeyCodeDialogVisible" />
		</div>
	</div>
</template>

<style lang="scss" scoped>
	@import "./index.scss";
</style>
<script>
  import index from "./index-Js";
  export default index;
</script>